<template>
  <aside class="smart-actions-panel" data-testid="smart-actions-side-panel">
    <Tabs :selected-tab="defaultTab" :options="{ useUrlFragment: false }">
      <Tab id="ai-actions" name="AI Actions" class="smart-actions-panel__tab">
        <AiActionsContent />
      </Tab>

      <Tab v-if="isMeeting" id="meeting-details" name="Meeting Details" class="smart-actions-panel__tab">
        <MeetingDetails />
      </Tab>

      <Tab v-if="hasChapters" id="chapters" name="Chapters" class="smart-actions-panel__tab">
        <ChaptersSection />
      </Tab>
    </Tabs>
  </aside>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { Tabs, Tab } from '@/storybook';

import AiActionsContent from './AiActionsContent.vue';
import MeetingDetails from './meeting/MeetingDetails.vue';
import ChaptersSection from './ChaptersSection.vue';

import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import { useChapters } from '@/modules/viewer/composables/useChapters';

const { isMeeting } = storeToRefs(useViewerItemStore());
const { hasChapters } = useChapters();

// The theater/mobile entry point for this panel labels itself "Meeting
// Details" for meetings (VideoOwnerLayout's theaterPanelLabel) — land on
// that tab by default so opening it doesn't show "AI Actions" instead of
// what the label promised.
const defaultTab = computed(() => (isMeeting.value ? '#meeting-details' : '#ai-actions'));
</script>

<style scoped>
.smart-actions-panel {
  @apply flex flex-col bg-white dark:bg-zinc-800 rounded-xl border border-zinc-200 dark:border-zinc-700 w-full p-4 sm:p-5;
}

.smart-actions-panel__tab {
  @apply pt-4;
}
</style>
